import { faBell } from '@fortawesome/pro-light-svg-icons/faBell'
import Icon from '@space-lib/components/icon'

import { NotificationBadge } from './styles'

export type NotificationIconProps = {
  showBadge: boolean
}

const NotificationIcon = ({ showBadge }: NotificationIconProps) => {
  return (
    <div className='relative inline-block' aria-label='notification icon'>
      <Icon icon={faBell} className='_text-gray-900 _text-3' aria-hidden='true' />
      {showBadge && <NotificationBadge aria-label='notification badge' role='status' />}
    </div>
  )
}

export default NotificationIcon
